// extracted by mini-css-extract-plugin
module.exports = {"modal-scroll":"colorPickerPopover_modal-scroll__BfRnM","popover-area":"colorPickerPopover_popover-area__AqiMV"};